import React  from "react";
import MainView from "../../../components/MainView";

import './styles.css'


export default function ReportsPage(props) {
    return (
        <MainView currentPage = 'reports' admFinMenu>
            <div>

            </div>
        </MainView>
    )
}